import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProjectFormType } from '../models/form/project-form-type.enum';
import { ProjectForm } from '../models/form/project-form.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectFormService extends RequestService<ProjectForm> {
  static PATH = '/project/form';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, ProjectFormService.PATH, globalService.debugUrl);
  }

  uploadFileWithoutProgress(
    file: File,
    projectId: number,
    stage: number,
    type?: ProjectFormType
  ) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('projectId', projectId.toString());
    formData.append('stage', stage.toString());
    if (type) {
      formData.append('type', type.toString());
    }
    return this.httpClient.post<string>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ProjectFormService.PATH}/upload`,
      formData
    );
  }
}
